import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';

export class FetchUserInfoFailure {
    static readonly type = '[User] FetchUserInfoFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}
